// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1Dwuu","list":"styles_list__3V8WI"};